import fetch from 'cross-fetch'

/**
 * Function to get correlation headers for api calls.
 *
 * @description You can use correlation IDs to match a particular request to a particular response, making it easier to troubleshoot unexpected issues, such as internal server errors.
 */
// export const getCorrelationHeaders = (sendXCorrelationId) => ({
//   'X-ApiSession-Id': getApiSessionId(),
//   [sendXCorrelationId ? 'x-correlation-id' : 'correlation-id']:
//     getCorrelationId(),
// });

/**
 * New Fetch wrapper for independent api calls
 */
export const fetchWrapper = async (endpoint, options = {headers: {}}, api = null) => {
    const response = await fetch(endpoint, {
        ...options,
        headers: {
            ...options.headers
        }
    })

    if (response.status === 403) {
        const clonedResponse = await response.clone()
        const responseJson = await clonedResponse.json()
        if (responseJson.errorCode === ACC_SUSPENDED) {
            api.auth.identityAccessManager.redirectToLogout()
        }
        return response
    }
    if (response.status === 401) {
        return response.json()
    }
    return response
}
